import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';
import { ValueAccessor } from '@ionic/angular/directives/control-value-accessors/value-accessor';

@Component({
  selector: 'app-selection-info',
  templateUrl: './selection-info.component.html',
  styleUrls: ['./selection-info.component.scss'],
})
export class SelectionInfoComponent implements OnInit {
  @Input() oddData: any;
  @Input() selectionData: any;

  

  constructor(public modalCtrl: ModalController, private navParams: NavParams) { 
  
  }
  //public value = this.navParams.get('selectionInfo_meta_data');
  
  // public isSportType = this.navParams.get('selectionInfo_meta_data').countryCode + this.navParams.get('selectionInfo_meta_data').sportName;
  // public chkStatus ='true';
  // public isjerseyIconShown = this.value.isjerseyIconShown;
  // public jerseyIcon = this.value.jerseyIcon;
  frontPath:string = "../../../assets/icon/default-jersey.png";
  
  //backPath:string = this.jerseyIcon;
  
  ngOnInit() {
    //console.log(this.selectionData);
    if(this.selectionData.FormFigures){
      this.selectionData.FormFigures = this.selectionData.FormFigures.split('').join(' ');
    }
    
  
    this.selectionData.runHistory = this.bindRunHistory(this.selectionData);

  }

  bindRunHistory(data){

    //console.log(data);

    if(data.runHistory){
      var runHis = data.runHistory;
      var horseForm = data.formfigures_figures;
      var HFArray = horseForm.substr(horseForm.length - 4).split("",4);
      HFArray.reverse();
     
      var newRunHis = [];
      if(runHis != '' && runHis != undefined){
        for(let j =0; j < runHis.length; j++){
          newRunHis.push({
            "date": runHis[j].date,
            "furlongs": runHis[j].furlongs,
            "place" : HFArray[j]
          });
        }
      }
        
      return newRunHis;
    }


  }

  dismiss() {
   
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }
  
}
